import React from 'react';
import { Col, Image, Row as AntRow } from 'antd';
import styled, { ITheme } from 'styled-components';
import BannerImg from 'src/assets/image/home/thumbnail.jpg';
import Slider from 'react-slick';

const Section = styled.div`
    .hot-new {
        margin: 0 auto;
        margin-top: 160px;
        max-width: 1272px;
        .current-project {
            width: 100%;
            justify-content: space-between;
            padding-bottom: 40px;
            .img-hot-new {
                width: 100%;
            }
        }
    }
    .current-project-fieldset {
        width: 100%;
        border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.green2};
        border-radius: 8px;
        .fieldset-title {
            width: 27%;
            color: ${({ theme }: { theme: ITheme }) => theme.white};
            margin-left: 100px;
            padding-left: 20px;
            .title-live {
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 52px;
                line-height: 66px;
                letter-spacing: 0.02em;
                color: ${({ theme }: { theme: ITheme }) => theme.text3};
            }
            .title-sales {
                color: ${({ theme }: { theme: ITheme }) => theme.white};
            }
        }
    }

    .slider-hot-new {
        width: 100%;
        .slick-next {
            right: 20px;
        }
        .slick-prev {
            left: 20px;
            z-index: 3;
        }
        .slick-list {
            padding-bottom: 15px;
        }
        .slick-dots {
            bottom: -30px;
            .slider-dot-custom {
                .slick-active {
                    width: 32px;
                    height: 8px;
                    background: ${({ theme }: { theme: ITheme }) => theme.text2};
                    border-radius: 4px;
                    .slider-dot-custom-item {
                        display: none;
                    }
                }
                li {
                    width: 8px;
                    height: 8px;
                    .slider-dot-custom-item {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        border: 1px solid ${({ theme }: { theme: ITheme }) => theme.text2};
                    }
                }
            }
        }
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
     .hot-new {
        .current-project {
            padding-top: 30px;
        }
    }
        .hot-new {
            margin: 0 auto;
            margin-top: 80px;
            padding: 0 12px;
            max-width: 100%;
            .current-project-fieldset {
                width: 100%;
                border: none;
                .fieldset-title {
                    width: 100%;
                    text-align: center;
                    margin-left: 0;
                    padding-left: 0;
                    .title-live {
                        font-family: 'Orbitron';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 22px;
                        line-height: 32px;
                        letter-spacing: 0.02em;
                    }
                }
            }
            .slider-hot-new {
                width: 100%;
                height: 100%;
                .slick-arrow {
                    display: none !important;
                }
                .slick-list {
                    padding-bottom: 15px;
                }
                .slick-dots {
                    bottom: -30px;
                    .slider-dot-custom {
                        .slick-active {
                            width: 32px;
                            height: 8px;
                            background: ${theme.text2};
                            border-radius: 4px;
                            .slider-dot-custom-item {
                                display: none;
                            }
                        }
                        li {
                            width: 8px;
                            height: 8px;
                            .slider-dot-custom-item {
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                border: 1px solid ${theme.text2};
                            }
                        }
                    }
                }
            }

        }
    `}
`;

function HotNew() {
    const settings: any = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        // autoplay: true,
        cssEase: 'linear',
        appendDots: (dots: any) => (
            <div>
                <ul className="slider-dot-custom"> {dots} </ul>
            </div>
        ),
        customPaging: () => <div className="slider-dot-custom-item" />,
    };
    return (
        <Section data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="500">
            <div className="hot-new">
                <fieldset className="current-project-fieldset">
                    <legend className="fieldset-title">
                        <span className="title-live">Hot</span>
                        <span className="title-sales title-live"> news</span>
                    </legend>
                    <AntRow className="home-section wrap-content-home-section">
                        <AntRow className="current-project">
                            <Slider className="slider-hot-new" {...settings}>
                                <Col
                                    className="hot-new-image"
                                    xs={{ span: 24, offset: 0 }}
                                    lg={{ span: 20, offset: 2 }}
                                >
                                    <Image preview={false} src={BannerImg} className="img-hot-new" />
                                </Col>
                                {/* <Col
                                    className="hot-new-image"
                                    xs={{ span: 24, offset: 0 }}
                                    lg={{ span: 20, offset: 2 }}
                                >
                                    <Image preview={false} src={BannerImg} className="img-hot-new" />
                                </Col>
                                <Col
                                    className="hot-new-image"
                                    xs={{ span: 24, offset: 0 }}
                                    lg={{ span: 20, offset: 2 }}
                                >
                                    <Image preview={false} src={BannerImg} className="img-hot-new" />
                                </Col> */}
                            </Slider>
                        </AntRow>
                    </AntRow>
                </fieldset>
            </div>
        </Section>
    );
}

export default HotNew;
